export default "__VITE_ASSET__B1dcUswP__"